export const SELLER_SESSION_STORAGE_KEY = 'jangi.sellerSession'

export type SellerStatus = 'PENDING' | 'APPROVED' | 'REJECTED' | 'SUSPENDED' | 'CLOSED'

export type SellerSession = {
  sellerCode: string
  sellerId: string
  storeName: string
  bizName: string
  bizNumber: string
  ownerName: string
  managerName: string
  phone: string
  email: string
  zipcode: string
  address: string
  addressDetail: string
  feeRate: number
  settleBank: string
  settleAccount: string
  settleHolder: string
  shippingFee: number
  freeShipOver: number
  returnFee: number
  cutoff?: string
  returnPolicy?: string
  notify?: {
    order: boolean
    claim: boolean
    stock: boolean
    inquiry: boolean
    settlement: boolean
  }
  grade: string
  status: SellerStatus
  rejectReason: string
  termsAgreed?: boolean
  createdBy?: 'SELF' | 'ADMIN'
  mustOnboard?: boolean
  pwTemp?: boolean
  onboardedAt?: string | null
  approvedAt: string | null
  joinedAt: string | null
  /** 최고관리자가 이 업체로 판매관리센터를 보고 있을 때만 온다. */
  viewingAsAdmin?: {
    adminId: string
    adminName: string
  } | null
}

export const SELLER_STATUS_LABEL: Record<SellerStatus, string> = {
  PENDING: '승인 심사 중',
  APPROVED: '정상 운영',
  REJECTED: '승인 반려',
  SUSPENDED: '이용 정지',
  CLOSED: '탈퇴',
}

export const SELLER_GRADE_LABEL: Record<string, string> = {
  NORMAL: '일반',
  GOOD: '우수',
  BEST: '최우수',
}

/** 심사가 끝나야 상품 등록·판매 같은 쓰기 동작을 허용한다. */
export function isSellerApproved(seller: SellerSession | null): boolean {
  return seller?.status === 'APPROVED'
}

export function saveSellerSession(seller: SellerSession) {
  sessionStorage.setItem(SELLER_SESSION_STORAGE_KEY, JSON.stringify(seller))
}

export function loadSellerSession(): SellerSession | null {
  const raw = sessionStorage.getItem(SELLER_SESSION_STORAGE_KEY)
  if (!raw) {
    return null
  }

  try {
    const parsed = JSON.parse(raw) as SellerSession
    if (!parsed.sellerCode || !parsed.sellerId) {
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function clearSellerSession() {
  sessionStorage.removeItem(SELLER_SESSION_STORAGE_KEY)
}
